<template>
  <div class="mntmoduleconfig" style="height: 100%">
    <div class="return">
      <el-button @click="submit" type="primary" class="searchBtn" :loading="loadingSave">{{$t('LanguageLib.SAVE')}}</el-button>
    </div>
    <div class="content">
      <div>
        <h4 class="title">{{$t('LanguageLib.REPAIR_MODULE_CONFIGURATION')}}</h4>
        <div class="checkbox">
          <div
            class="checkboxItem"
            v-for="(item, index) in checkList"
            :key="index"
            :title="item.value"
          >
            <el-checkbox v-model="item.model">{{item.value}}</el-checkbox>
          </div>
        </div>
      </div>
      <div>
        <div style="padding-left: 16px;">
            <div style="margin-bottom: 25px;">
              <span style="font-size: 14px;font-weight: 400;color: #4D4D4D;margin-bottom: 6px;display: inline-block;">
                {{$t('LanguageLib.APPLY_FOR_REPAIRS')}}
              </span>
              <div>
                <el-input-number @input.native="onInput0_3" v-model="mntRequestImgCount" @change="(value) => {inputNum(value, 0)}" :min="0" :max="3" style="width: 160px;height: 40px;"></el-input-number>
              </div>
            </div>
            <div style="margin-bottom: 25px;">
              <span style="font-size: 14px;font-weight: 400;color: #4D4D4D;margin-bottom: 6px;display: inline-block;">
                {{$t('LanguageLib.ACCEPT_PICTURE_CONFIGURATION')}}
              </span>
              <div>
                <el-input-number @input.native="onInput0_3" v-model="mntAcceptanceImgCount" @change="(value) => {inputNum(value, 1)}" :min="0" :max="3" style="width: 160px;height: 40px;"></el-input-number>
              </div>
            </div>
            <div style="margin-bottom: 25px;">
              <el-checkbox style="margin-bottom: 6px;" v-model="openFinishIssueDayMnt">{{$t('LanguageLib.AUTO_SUCCESS')}}</el-checkbox>
              <div style="padding-left:24px;">
                <span style="font-size: 14px;font-weight: 400;color: #666666;margin-right: 10px;">
                  {{$t('LanguageLib.z_info_common_000047')}}
                </span>
                <el-input-number  @input.native="onInput0_999" :disabled="!openFinishIssueDayMnt" @change="(value) => {inputNum(value, 2)}" v-model="finishIssueDayMnt" :min="0" :max="999" style="width: 160px;height: 40px;"></el-input-number>
                <span style="font-size: 14px;font-weight: 400;color: #666666;margin-left: 10px;">
                  {{$t('LanguageLib.DAY')}}
                </span>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import companyallocationApi from '../../api/companyallocation'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'companyallocation',
  props: ['currentPage', 'pageSize', 'searchText', 'sort', 'sortOrder'],
  data () {
    return {
      checkList: [{
        value: this.$t('LanguageLib.STORE_AGENT'),
        model: false,
        type: 0
      }, {
        value: this.$t('LanguageLib.COST_RECORD'),
        model: false,
        type: 1
      }, {
        value: this.$t('LanguageLib.OPEN_INQUIRY'),
        model: false,
        type: 2
      }, {
        value: this.$t('LanguageLib.PROJECT_MAINTENANCE'),
        model: false,
        type: 3
      }, {
        value: this.$t('LanguageLib.PROBLEM_DESCRIPTION_REQUIRED'),
        model: false,
        type: 4
      }, {
        value: this.$t('LanguageLib.ACCEPTANCE_SCORING_REQUIRED'),
        model: false,
        type: 5
      }],
      openFinishIssueDayMnt: false, // 是否自动完成
      mntRequestImgCount: 0, // 报修申请提交图片配置
      mntAcceptanceImgCount: 0, // 验收图片配置
      finishIssueDayMnt: 0, // 自动验收后完成的天数
      loadingSave: false // 保存按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    companyallocationApi.GetMntsetting('get', '/OwnerInfo/mntsetting', { ownerId: window.localStorage.getItem('ownerId') })
      .then(res => {
        NProgress.done()
        next(vm => {
          vm.mntRequestImgCount = res.data.mntRequestImgCount
          vm.mntAcceptanceImgCount = res.data.mntAcceptanceImgCount
          vm.openFinishIssueDayMnt = res.data.openFinishIssueDayMnt
          vm.finishIssueDayMnt = res.data.finishIssueDayMnt
          for (var i in vm.checkList) {
            switch (vm.checkList[i].type) {
              case 0:
                vm.checkList[i].model = res.data.isStoreTasking
                break
              case 1:
                vm.checkList[i].model = res.data.isViewMntCost
                break
              case 2:
                vm.checkList[i].model = res.data.openEnquiry
                break
              case 3:
                vm.checkList[i].model = res.data.openMntProject
                break
              case 4:
                vm.checkList[i].model = res.data.mustMntContent
                break
              case 5:
                vm.checkList[i].model = res.data.mustMntAcceptanceScore
                break
            }
          }
        })
      })
      .catch(err => {
        console.log(err)
      })
  },
  created () {
  },
  methods: {
    inputNum (value, type) {
      if (value === undefined || value === '') {
        switch (type) {
          case 0:
            this.mntRequestImgCount = 0
            break
          case 1:
            this.mntAcceptanceImgCount = 0
            break
          case 2:
            this.finishIssueDayMnt = 0
            break
        }
      }
    },
    onInput0_999 (e) {
      // 验证是否是纯数字
      const isNumber = /^\d*$/.test(e.target.value)
      // 过滤非数字
      e.target.value = e.target.value.replace(/\D/g, 0)
      if (!isNumber || e.target.value < 0) {
        e.target.value = 0
      }
      if (!isNumber || e.target.value > 999) {
        e.target.value = 999
      }
      if (e.target.value === '') {
        e.target.value = 0
      }
      e.target.value = (e.target.value >= 0 && e.target.value <= 999 && e.target.value.match(/^\d*/g)[0]) || null
    },
    onInput0_3 (e) {
      // 验证是否是纯数字
      const isNumber = /^\d*$/.test(e.target.value)
      // 过滤非数字
      e.target.value = e.target.value.replace(/\D/g, 0)
      if (!isNumber || e.target.value < 0) {
        e.target.value = 0
      }
      if (!isNumber || e.target.value > 3) {
        e.target.value = 3
      }
      if (e.target.value === '') {
        e.target.value = 0
      }
      e.target.value = (e.target.value >= 0 && e.target.value <= 3 && e.target.value.match(/^\d*/g)[0]) || null
    },
    // 保存数据
    submit () {
      this.loadingSave = true
      var isStoreTasking = false
      var isViewMntCost = false
      var openEnquiry = false
      var openMntProject = false
      var mustMntContent = false
      var mustMntAcceptanceScore = false
      for (var i in this.checkList) {
        switch (this.checkList[i].type) {
          case 0:
            isStoreTasking = this.checkList[i].model
            break
          case 1:
            isViewMntCost = this.checkList[i].model
            break
          case 2:
            openEnquiry = this.checkList[i].model
            break
          case 3:
            openMntProject = this.checkList[i].model
            break
          case 4:
            mustMntContent = this.checkList[i].model
            break
          case 5:
            mustMntAcceptanceScore = this.checkList[i].model
            break
        }
      }
      var data = {
        ownerId: this.$commonfun.localStorage.getitem('ownerId'),
        isStoreTasking: isStoreTasking,
        isViewMntCost: isViewMntCost,
        openEnquiry: openEnquiry,
        openMntProject: openMntProject,
        mustMntContent: mustMntContent,
        mustMntAcceptanceScore: mustMntAcceptanceScore,
        openFinishIssueDayMnt: this.openFinishIssueDayMnt,
        mntRequestImgCount: this.mntRequestImgCount,
        mntAcceptanceImgCount: this.mntAcceptanceImgCount,
        finishIssueDayMnt: this.finishIssueDayMnt
      }
      companyallocationApi.SaveMntsettingchange('post', '/OwnerInfo/mntsettingchange', data)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.SAVED_SUCCESSFULLY')
          })
          this.loadingSave = false
        })
        .catch(err => {
          this.loadingSave = false
          this.$commonfun.console.log(err)
        })
    }
  }
}
</script>

<style lang="scss">
.mntmoduleconfig{
  ul{
    margin: 0;
    padding: 0;
  }
  li{
    list-style: none;
  }
  .return{
    padding-left: 25px;
    position: relative;
    height:50px;
    background:rgba(255,255,255,1);
    line-height: 50px;
    border-bottom: 1px solid #F2F2F2;
  }
  .content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 5px;
    background: #fff;
  }
  .content{
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    width: 100%;
    height: calc( 100% - 50px);
    overflow-y: auto;
    padding-left: 25px;
    padding-top: 15px;
    .title{
      font-size: 16px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 20px;
      .remarks{
        width: 12px;
        height: 12px;
        background: #C9C9C9;
        border-radius: 50%;
        display: inline-block;
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 12px;
      }
    }
    .ModuleBox::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .ModuleBox::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      background: #E1E1E1;
    }
    .ModuleBox::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      border-radius: 5px;
      background: #fff;
    }
    .ModuleBox{
      width: 300px;
      height: 400px;
      border: 1px solid #E1E1E1;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;
      .el-divider--horizontal{
        margin: 0;
        width: calc(100% - 10px);
      }
      .el-collapse-item__wrap{
        border: 0;
      }
      .el-collapse-item__header{
        border: 0;
      }
      .el-collapse-item {
        padding-left: 10px;
      }
      .el-collapse-item__content {
        padding: 0;
      }
    }
    .checkbox{
      padding-left: 16px;
      display: flex;
      flex-wrap: wrap;
      .checkboxItem{
        width: 240px;
        margin-right: 10px;
        margin-bottom: 20px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #606266;
        .el-checkbox{
          margin-right: 10px;
        }
        .el-checkbox__label{
          width: 216px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          vertical-align: bottom;
        }
      }
    }
  }
  // 修改按钮样式
  .el-button--primary{
    background-color: #3BC6B9;
    border-color: #3BC6B9;
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  // 修改按钮样式
  .el-button--default{
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  .el-button--default:focus, .el-button--default:hover{
    color: #3BC6B9;
    border-color: #3BC6B9;
  }
  .el-textarea__inner{
    font: 400 14px Arial;
  }
  .el-input .is-disabled{
    color: #2c3e50;
  }
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #606266;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}

</style>
